import { Github, Twitter, Linkedin, Mail, MapPin, Phone } from 'lucide-react';
import obrimLogo from '@/assets/obrim-logo-transparent.png';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerSections = [
    {
      title: 'Produto',
      links: [
        { name: 'Soluções', href: '#solutions' },
        { name: 'Preços', href: '#pricing' },
        { name: 'Demonstração', href: '#demo' },
        { name: 'API', href: '#api' }
      ]
    },
    {
      title: 'Empresa',
      links: [
        { name: 'Sobre nós', href: '#about' },
        { name: 'Carreiras', href: '#careers' },
        { name: 'Blog', href: '#blog' },
        { name: 'Imprensa', href: '#press' }
      ]
    },
    {
      title: 'Suporte',
      links: [
        { name: 'Central de Ajuda', href: '#help' },
        { name: 'Documentação', href: '#docs' },
        { name: 'Status', href: '#status' },
        { name: 'Contato', href: '#contact' }
      ]
    },
    {
      title: 'Legal',
      links: [
        { name: 'Privacidade', href: '#privacy' },
        { name: 'Termos', href: '#terms' },
        { name: 'Cookies', href: '#cookies' },
        { name: 'Segurança', href: '#security' }
      ]
    }
  ];

  return (
    <footer className="bg-secondary/20 border-t border-border">
      <div className="container mx-auto px-4 py-16">
        <div className="grid md:grid-cols-5 gap-8">
          {/* Company Info */}
          <div className="md:col-span-1">
            <div className="flex items-center mb-6">
              <img 
                src={obrimLogo} 
                alt="Obrim - Gestão de Obras"
                className="h-8 w-auto"
              />
            </div>
            
            <p className="text-muted-foreground mb-6 text-sm leading-relaxed">
              Transformando a engenharia e arquitetura com inteligência artificial 
              para um futuro mais eficiente e sustentável.
            </p>

            <div className="space-y-3 text-sm">
              <div className="flex items-center space-x-2 text-muted-foreground">
                <MapPin className="h-4 w-4" />
                <span>São Paulo, SP - Brasil</span>
              </div>
              <div className="flex items-center space-x-2 text-muted-foreground">
                <Phone className="h-4 w-4" />
                <span>+55 (41) 98440-4341</span>
              </div>
              <div className="flex items-center space-x-2 text-muted-foreground">
                <Mail className="h-4 w-4" />
                <span>contato@obrim.com.br</span>
              </div>
            </div>
          </div>

          {/* Footer Sections */}
          {footerSections.map((section, index) => (
            <div key={index}>
              <h3 className="font-semibold text-foreground mb-4">
                {section.title}
              </h3>
              <ul className="space-y-3">
                {section.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <a
                      href={link.href}
                      className="text-muted-foreground hover:text-foreground transition-colors text-sm"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Section */}
        <div className="border-t border-border mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <div className="text-muted-foreground text-sm mb-4 md:mb-0">
            © {currentYear} Obrim. Todos os direitos reservados.
          </div>

          <div className="flex items-center space-x-6">
            <div className="flex items-center space-x-1 text-xs text-muted-foreground">
              <span>Feito com</span>
              <span className="text-red-500">❤️</span>
              <span>no Brasil</span>
            </div>
            
            <div className="flex items-center space-x-4">
              <a
                href="#"
                className="text-muted-foreground hover:text-foreground transition-colors"
                aria-label="GitHub"
              >
                <Github className="h-5 w-5" />
              </a>
              <a
                href="#"
                className="text-muted-foreground hover:text-foreground transition-colors"
                aria-label="Twitter"
              >
                <Twitter className="h-5 w-5" />
              </a>
              <a
                href="#"
                className="text-muted-foreground hover:text-foreground transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};